import React, { useContext } from 'react';
import PricingTable from '../components/pricing/PricingTable';
import ScrollButton from '../components/scroll-button/ScrollButton';
import StandardPage from '../components/StandardPage';
import UserLocationContext from '../components/user-location/UserLocationContext';

export default () => {
    const userLocation = useContext(UserLocationContext);
    return (
        <StandardPage subtitle="Pricing">
            <main>
                <header className="wrapper text-center pt-8">
                    <h1>Pricing</h1>
                    <p>Simple transparent pricing for all sizes of farm.</p>
                </header>
                <PricingTable userLocation={userLocation} />
                <ScrollButton />
            </main>
        </StandardPage>
    );
};
